// index.js
import { default as statusReducer } from './reducers';
export { default as statusOperations } from './operations';
export { default as statusTypes } from './types';
export default statusReducer;